import styles from "./BottomBar.module.scss";
import { useHistory } from "react-router-dom";
import { SearchConfActionType, useConfig } from "../../reducers/searchConfReducer";
import { DoorType } from "../../common/CommonType";
import BuserBottomBar from "../BuserBottomBar/BuserBottomBar";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { next_step_size_filter_gio } from "@/utils/gioUtils";
import { GIO, GioModuleVar } from "@/utils/gioUtils";
import { usePaxConfig } from "@/reducers/paxReducer";

interface IProps {
  text?: string;
  nextStepFn?: (() => void) | null;
}

function BottomBar(props: IProps, ref: any) {
  const isOnline2offline = sessionStorage.getItem('abtestPaxOnline2offline') === 'SHOW'
  const { text, nextStepFn } = props
  const { state, dispatch } = useConfig()
  const { state: paxState } = usePaxConfig()
  const history = useHistory();
  const [showAll, setShowAll] = useState(true);
  const [k, setK] = useState(0);
  function handleClick(isShowAll?: boolean) {
    if (nextStepFn) return nextStepFn()
    if (state.doorTipVisibility && state.doorType === DoorType.NONE) {
      dispatch({
        type: SearchConfActionType.UpdateConfig,
        payload: Object.assign({}, state, { showDoorTip: true })
      })
    } else {
      const temp = paxState.recommendTemplate?.wardrobeWithProduct
      const combination = temp?.combination || ""
      const size = temp?.totalLength + "_" + temp?.height + "_" + temp?.depth
      GIO('track', 'clickData', {
        eventType_var: 'click',
        module_var: GioModuleVar.footerTab,
        objectName_var: "下一步",
        doorShape_var:
          state.doorType === DoorType.HINGE
            ? '合叶门' : state.doorType === DoorType.SLIDING ? '滑门' : '无门',
        size_var: size,
        elementColor_var: temp?.color || "",
        elementSize_var: combination.replaceAll(",", "_"),
      })
      history.push("/interior_design");
    }
    next_step_size_filter_gio(isShowAll)
  }

  useImperativeHandle(ref, () => ({
    setShowAll: (flag: boolean) => {
      setShowAll(flag);
      if (isOnline2offline) {
        setK((k) => k + 1);
      }
    }
  }));

  useEffect(() => {
    if (isOnline2offline) {
      setShowAll(false)
    }
  }, [])

  return (
    <div className={styles.Container}>
      <BuserBottomBar
        nextSteptext={'下一步2/3: 储物需求选择'}
        modify={k}
        showAll={showAll}
        showBar={true}
        nowProgess={1}
        nextStepFn={handleClick}
        nextStepBtnText={'下一步'}
        nowPage={'BasicInfo'}
      />
    </div>)
}

export default forwardRef(BottomBar);
